module.exports = __webpack_public_path__ + "media/images/virtualahan-3766a2c04deb9d551ed5ef783bac70a7.png";